<div class="access-container">
  <mat-form-field
    appearance="outline"
    class="text-primary border-primary select-primary"
  >
    <mat-select [(ngModel)]="accessSelect">
      <mat-option value="" disabled>Add {{ label }}</mat-option>
      @for (idx of allIndices; track idx.name) {
        <mat-option (click)="addIndex(idx)" [value]="idx">{{
          idx.name
        }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  @for (idx of indices; track idx.name) {
    <button
      type="button"
      mat-stroked-button
      class="rounded-pill pill-btn"
      (click)="removeIndex(idx)"
    >
      {{ idx.name }} <mat-icon>close</mat-icon>
    </button>
  }
</div>
